export default {
  ['list'](state, payload) {
    state.list = payload;
  },
};
